import {
	isRichTextEmpty,
	stripRichText,
} from '../components/Reusables/RichText/richTextConfig';

const escapeHtml = (text) =>
	String(text ?? '')
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;');

const plainToHtml = (plain) =>
	escapeHtml(String(plain ?? ''))
		.replace(/\r\n/g, '\n')
		.replace(/\r/g, '\n')
		.replace(/\n/g, '<br>');

/** Merges draft body with company outreach signature (plain + HTML). */
export const formatOutreachEmail = (body, outreachSettings) => {
	const base = String(body ?? '');
	const settings = outreachSettings || {};
	if (!settings.appendSignature || isRichTextEmpty(settings.signature)) {
		return { text: base, html: plainToHtml(base) };
	}

	const sigHtml = String(settings.signature || '').trim();
	const sigText = stripRichText(sigHtml);
	const trimmedBase = base.trimEnd();

	const text = trimmedBase
		? sigText
			? `${trimmedBase}\n\n${sigText}`
			: trimmedBase
		: sigText;
	const html = trimmedBase
		? `${plainToHtml(trimmedBase)}<br><br>${sigHtml}`
		: sigHtml;

	return { text, html };
};

/** Plain text for mailto links and clipboard. */
export const appendOutreachSignature = (body, outreachSettings) =>
	formatOutreachEmail(body, outreachSettings).text;

export const defaultOutreachSettings = () => ({
	appendSignature: false,
	signature: '',
});
